import Joi from "joi";

export default Joi.object({
	username: Joi.string().required(),
	system_code: Joi.string().required(),
	region: Joi.string().valid("eu", "latam").required()
});
